import { take, call, put, select, spawn, fork } from 'redux-saga/effects';
import { eventChannel } from 'redux-saga';
import { isDefined, mergeConfigs, isWebConfig, isMobileDevice, isEmptyObject, forwardTo, mergeTranslate, hexToRgb, deepCopy, getDefaultRoute } from '../../lib/utils';
import api from '../../lib/api';
import { sortLocations } from '../../lib/utils';
import WebFont from 'webfontloader';
import { App as AppCap } from '@capacitor/app';
import {
  LOADING,
  REQUEST_ERROR,
  SEND_FIREBASE_TOKEN,
  INIT,
  SET_COMMON_PROP,
  GET_SOCIALS,
  SEND_FEEDBACK,
  SET_COMMON_MODAL,
  GET_TERMS,
  GET_PRIVACY_POLICY,
  GET_FAQ,
  INIT_FIREBASE,
  LOCATION,
  INIT_FIREBASE_DATABASE,
  GET_ORDER_PRODUCTION_MINS,
  GET_NEWS,
  SET_NEWS,
  SET_NAVCONFIG,
  GET_NUTRITION_DATA,
  SET_NUTRITION_DATA,
  ADD_TO_APPLE_WALLET,
  ADD_TO_WALLET,
  GET_MILESTONE_INFO,
  GET_LOYALTY_INFO,
  GET_UNLOCK_INFO,
  INIT_FIREBASE_LISTENER,
  GET_ALLERGENS,
} from './constants';
import { UPDATE_PROFILE, GET_PROFILE, GET_VOUCHERS, LOGOUT, GET_GIFT_CARDS, GET_NOTIFICATIONS } from '../profile/constants';
import { SET_ORDERS_PROP, GET_ORDER_HISTORY, SET_LATEST_ORDER_EVENT, GET_EVENT } from '../orders/constants';
import {
  SET_RESTAURANT_PROP,
  GET_RESTAURANTS_SNOOZED_DATA,
  GET_RESTAURANTS,
  GET_IKENTOO_MENU,
  GET_TABLE_BY_ID,
  GET_TAX_DATA,
  SET_TABLE_DATA,
  GET_REWARDS,
} from '../restaurants/constants';
import { Capacitor, registerPlugin } from '@capacitor/core';
import { translate } from '../../lib/translate';
import { setCatalog } from '../../translationCatalogWrapper';
import { updateConfig, getConfig } from '../../appConfig';
import { restoreAuthSaga } from '../profile/sagas';
import { buildCuratedMenuSaga } from '../orders/sagas';
import { errorHandlerSaga } from '../sagas';
import 'firebase/database';
import 'firebase/storage';
import asyncStorage from '../../lib/asyncStorage';
import LibStripe from '../../lib/stripe';
import { initRouter } from '../../navConfig';
import { showToast } from './actions';
import { SplashScreen } from '@capacitor/splash-screen';
import { PushNotifications } from '@capacitor/push-notifications';
import { Device } from '@capacitor/device';
import Basket from '../../lib/basket';
import { getFeedbackMetadata } from '../../lib/feedbackMetadata';
import packageJson from '../../../package.json';
import { initializeApp, getApp, getApps } from 'firebase/app';
import { getDatabase, off, onValue, ref } from 'firebase/database';
import { filterMenu, getTableNumbers } from '../restaurants/sagas';
import translationCatalog from '../../lib/translations.json';

export const loading = function* (fn = null) {
  try {
    if (!isDefined(fn)) {
      return;
    }
    yield put({ type: LOADING, loading: true });
    if (fn) {
      yield call(fn);
    }
  } finally {
    yield put({ type: LOADING, loading: false });
  }
};

/**
 * send firebase token saga
 */
// TO DO: CHECK THIS (AP)
export const sendFirebaseToken = function* () {
  while (true) {
    const request = yield take(SEND_FIREBASE_TOKEN);
    yield call(loading, function* () {
      try {
        yield call(api.sendFirebaseToken, request.args);
      } catch (error) {
        yield put({ type: REQUEST_ERROR, error: error.message });
      }
    });
  }
};
const setCustomDesign = (styles, customCss, images, useCustomFonts, customButtons) => {
  let documentStyle = document.createElement('style');
  let css = customCss;
  let theme = styles.theme || 'white';
  const themeWrapper = document.querySelector('body');
  const invertSideMenu = styles.invertSideMenu;
  if (customButtons?.orderUserModal) {
    const cssString = Object.entries(customButtons.orderUserModal)
      .map(([className, color]) => `.alert-button-group button.primary.order-user-modal-${className} { --ion-color-primary: ${color} !important; }`)
      .join('\n');
    css += cssString
  }
  if (styles.colors) {
    if (!styles.colors['--okx-menu-background-overlay'] && styles.colors['--okx-box-wrapper-shadow']) {
      css += `ion-accordion,.sidebar-home,.order-list-item {
        box-shadow:0px 5px 10px 0px ${styles.colors['--okx-box-wrapper-shadow']}
      }`;
    }
    Object.entries(styles.colors).map(([key, value]) => {
      themeWrapper.style.setProperty(key, value);
      if (styles.colors['--okx-rewards-box-color-light'] && !styles.colors['--okx-rewards-box-color-dark']) {
        themeWrapper.style.setProperty(
          '--okx-rewards-box-color-dark',
          styles.colors['--okx-rewards-box-color-light'],
        );
      }
      if (!styles.colors['--okx-rewards-box-color-light'] && styles.colors['--okx-rewards-box-color-dark']) {
        themeWrapper.style.setProperty(
          '--okx-rewards-box-color-light',
          styles.colors['--okx-rewards-box-color-dark'],
        );
      }
      if (styles.colors['--ion-color-primary']) {
        if (!styles.colors['--okx-filter-pill-border']) {
          themeWrapper.style.setProperty(
            '--okx-filter-pill-border',
            styles.colors['--ion-color-primary'],
          );
        }
        if (!styles.colors['--okx-filter-pill-color']) {
          themeWrapper.style.setProperty(
            '--okx-filter-pill-color',
            styles.colors['--ion-color-primary'],
          );
        }
        if (!styles.colors['--okx-rewards-box-color-light'] && !styles.colors['--okx-rewards-box-color-dark']) {
          themeWrapper.style.setProperty(
            '--okx-rewards-box-color-light',
            styles.colors['--ion-color-primary'],
          );
          themeWrapper.style.setProperty(
            '--okx-rewards-box-color-dark',
            styles.colors['--ion-color-primary'],
          );
        }
        if (!styles.colors['--okx-active-modifier-border']) {
          themeWrapper.style.setProperty(
            '--okx-active-modifier-border',
            styles.colors['--ion-color-primary'],
          );
        }
        if (!styles.colors['--okx-active-bottom-navigation-background']) {
          themeWrapper.style.setProperty(
            '--okx-active-bottom-navigation-background',
            styles.colors['--ion-color-primary'],
          );
        }
        if (!styles.colors['--okx-basket-counter-background']) {
          themeWrapper.style.setProperty(
            '--okx-basket-counter-background',
            styles.colors['--ion-color-primary'],
          );
        }
        if (!styles.colors['--ion-color-secondary']) {
          themeWrapper.style.setProperty(
            '--ion-color-secondary',
            styles.colors['--ion-color-primary'],
          );
        }
        if (!styles.colors['--okx-pagination-background']) {
          themeWrapper.style.setProperty(
            '--okx-pagination-background',
            styles.colors['--ion-color-primary'],
          );
        }
        if (!styles.colors['--okx-pagination-active-background']) {
          themeWrapper.style.setProperty(
            '--okx-pagination-active-background',
            styles.colors['--ion-color-primary'],
          );
        }
        if (!styles.colors['--okx-service-charge-pill-background']) {
          themeWrapper.style.setProperty(
            '--okx-service-charge-pill-background',
            styles.colors['--ion-color-primary'],
          );
        }
        if (!styles.colors['--okx-active-category-border']) {
          themeWrapper.style.setProperty(
            '--okx-active-category-border',
            styles.colors['--ion-color-primary'],
          );
        }

        themeWrapper.style.setProperty('--ion-color-primary-rgb', hexToRgb(styles.colors['--ion-color-primary'], true));
      }
      if (styles.colors['--ion-color-secondary']) {
        themeWrapper.style.setProperty('--ion-color-secondary-rgb', hexToRgb(styles.colors['--ion-color-secondary'], true));
      }
      if (styles.colors['--text-color']) {
        if (!styles.colors['--okx-basket-icon-color']) {
          themeWrapper.style.setProperty(
            '--okx-basket-icon-color',
            styles.colors['--text-color'],
          );
        }
      }
      if (styles.colors['--ion-color-primary-contrast']) {

        if (!styles.colors['--okx-filter-pill-background']) {
          themeWrapper.style.setProperty(
            '--okx-filter-pill-background',
            styles.colors['--ion-color-primary-contrast'],
          );
        }

        if (!styles.colors['--okx-rewards-box-color-light'] && !styles.colors['--okx-rewards-box-color-dark']) {
          themeWrapper.style.setProperty(
            '--okx-rewards-box-color-dark-contrast',
            styles.colors['--ion-color-primary-contrast'],
          );
        }

        if (!styles.colors['--okx-active-bottom-navigation-color']) {
          themeWrapper.style.setProperty(
            '--okx-active-bottom-navigation-color',
            styles.colors['--ion-color-primary-contrast'],
          );
        }
        if (!styles.colors['--okx-basket-counter-color']) {
          themeWrapper.style.setProperty(
            '--okx-basket-counter-color',
            styles.colors['--ion-color-primary-contrast'],
          );
        }
      }



      if (styles.colors['--okx-box-wrapper-border']) {

        if (!styles.colors['--okx-modifier-border']) {
          themeWrapper.style.setProperty(
            '--okx-modifier-border',
            styles.colors['--okx-box-wrapper-border'],
          );
        }
      }
      if (styles.colors['--okx-box-wrapper-color']) {

        if (!styles.colors['--okx-inactive-bottom-navigation-color']) {
          themeWrapper.style.setProperty(
            '--okx-inactive-bottom-navigation-color',
            styles.colors['--okx-box-wrapper-color'],
          );
        }
        if (!styles.colors['--okx-multivenue-restaurants-pill-background']) {
          themeWrapper.style.setProperty(
            '--okx-multivenue-restaurants-pill-background',
            styles.colors['--okx-box-wrapper-color'],
          );
        }
        if (!styles.colors['--okx-dashboard-bar-color']) {
          themeWrapper.style.setProperty(
            '--okx-dashboard-bar-color',
            styles.colors['--okx-box-wrapper-color'],
          );
        }
      }
      if (styles.colors['--okx-box-wrapper-background']) {
        if (!styles.colors['--okx-inactive-bottom-navigation-background']) {
          themeWrapper.style.setProperty(
            '--okx-inactive-bottom-navigation-background',
            styles.colors['--okx-box-wrapper-background'],
          );
        }
        if (!styles.colors['--okx-box-wrapper-shade']) {
          themeWrapper.style.setProperty(
            '--okx-box-wrapper-shade',
            styles.colors['--okx-box-wrapper-background'],
          );
        }
        if (!styles.colors['--okx-multivenue-restaurants-pill-color']) {
          themeWrapper.style.setProperty(
            '--okx-multivenue-restaurants-pill-color',
            styles.colors['--okx-box-wrapper-background'],
          );
        }
        if (!styles.colors['--okx-dashboard-bar-background']) {
          themeWrapper.style.setProperty(
            '--okx-dashboard-bar-background',
            styles.colors['--okx-box-wrapper-background'],
          );
        }

      }


      if (theme == 'dark') {
        themeWrapper.style.setProperty('--okx-background-color', '#4D4D4D');
        themeWrapper.style.setProperty('--okx-box-wrapper-background', '#292929');
        themeWrapper.style.setProperty('--okx-box-wrapper-color', '#ffffff');
        themeWrapper.style.setProperty('--okx-textfield-background', '#000000');
        themeWrapper.style.setProperty('--okx-textfield-color', '#FFFFFF');
        themeWrapper.style.setProperty('--okx-textfield-border', '#000000');
        themeWrapper.style.setProperty('--ion-color-gray', '#8c8b8b');
        themeWrapper.style.setProperty('--okx-menu-background', '#292929');
        themeWrapper.style.setProperty('--okx-nav-title-color', '#acacac');
        if (!styles.colors['--okx-text-color']) {
          themeWrapper.style.setProperty('--okx-text-color', '#ffffff');
        }
        if (invertSideMenu) {
          themeWrapper.style.setProperty(
            '--okx-menu-background',
            styles.colors['--ion-color-primary'],
          );
          themeWrapper.style.setProperty(
            '--okx-menu-color',
            styles.colors['--ion-color-primary-contrast'],
          );
          themeWrapper.style.setProperty(
            '--okx-menu-icon-color',
            styles.colors['--ion-color-primary-contrast'],
          );
          themeWrapper.style.setProperty(
            '--okx-menu-button-text',
            styles.colors['--ion-color-primary'],
          );
          themeWrapper.style.setProperty(
            '--okx-menu-button-background',
            styles.colors['--ion-color-primary-contrast'],
          );
        } else {
          themeWrapper.style.setProperty('--okx-menu-icon-color', '#fffff');
          themeWrapper.style.setProperty('--okx-menu-color', '#ffffff');
          themeWrapper.style.setProperty('--okx-menu-button-text', '#000000');
          themeWrapper.style.setProperty('--okx-menu-button-background', '#ffffff');
          themeWrapper.style.setProperty('--okx-menu-icon-color', '#ffffff');
        }
      } else if (theme == 'light') {
        themeWrapper.style.setProperty('--okx-background-color', '#F5F5F5');
        themeWrapper.style.setProperty('--okx-box-wrapper-background', '#ffffff');
        themeWrapper.style.setProperty('--okx-box-wrapper-color', '#000000');
        themeWrapper.style.setProperty('--okx-textfield-background', '#ffffff');
        themeWrapper.style.setProperty('--okx-textfield-color', '#000000');
        themeWrapper.style.setProperty('--okx-textfield-border', '#ffffff');
        themeWrapper.style.setProperty('--ion-color-gray', '#EBEBEB');
        themeWrapper.style.setProperty('--okx-nav-title-color', '#acacac');
        if (!styles.colors['--okx-text-color']) {
          themeWrapper.style.setProperty('--okx-text-color', '#000000');
        }
        if (invertSideMenu) {
          themeWrapper.style.setProperty(
            '--okx-menu-background',
            styles.colors['--ion-color-primary'],
          );
          themeWrapper.style.setProperty(
            '--okx-menu-color',
            styles.colors['--ion-color-primary-contrast'],
          );
          themeWrapper.style.setProperty(
            '--okx-menu-icon-color',
            styles.colors['--ion-color-primary-contrast'],
          );
          themeWrapper.style.setProperty(
            '--okx-menu-button-text',
            styles.colors['--ion-color-primary'],
          );
          themeWrapper.style.setProperty(
            '--okx-menu-button-background',
            styles.colors['--ion-color-primary-contrast'],
          );
        } else {
          themeWrapper.style.setProperty('--okx-menu-background', '#ffffff');
          themeWrapper.style.setProperty('--okx-menu-color', '#000000');
          themeWrapper.style.setProperty('--okx-menu-icon-color', '#000000');
          themeWrapper.style.setProperty('--okx-menu-button-text', '#ffffff');
          themeWrapper.style.setProperty('--okx-menu-button-background', '#000000');
        }
      } else {
        if (styles.colors['--ion-color-secondary-contrast']) {
          themeWrapper.style.setProperty(
            '--ion-color-secondary-contrast',
            styles.colors['--ion-color-secondary-contrast'],
          );
        }
        if (styles.colors['--okx-background-color']) {
          themeWrapper.style.setProperty(
            '--okx-background-color',
            styles.colors['--okx-background-color'],
          );
        }
        if (styles.colors['--okx-box-wrapper-background']) {
          themeWrapper.style.setProperty(
            '--okx-box-wrapper-background',
            styles.colors['--okx-box-wrapper-background'],
          );
        }
        if (styles.colors['--okx-box-wrapper-color']) {
          themeWrapper.style.setProperty(
            '--okx-box-wrapper-color',
            styles.colors['--okx-box-wrapper-color'],
          );
        }
        if (!styles.colors['--okx-text-color']) {
          themeWrapper.style.setProperty('--okx-text-color', '#666666');
        }
        if (styles.colors['--okx-box-wrapper-shadow']) {
          themeWrapper.style.setProperty(
            '--okx-box-wrapper-shadow',
            styles.colors['--okx-box-wrapper-shadow'],
          );
        }
        if (styles.colors['--okx-box-wrapper-border']) {
          themeWrapper.style.setProperty(
            '--okx-box-wrapper-border',
            styles.colors['--okx-box-wrapper-border'],
          );
        }
        if (styles.colors['--okx-textfield-background']) {
          themeWrapper.style.setProperty(
            '--okx-textfield-background',
            styles.colors['--okx-textfield-background'],
          );
        }
        if (styles.colors['--okx-textfield-color']) {
          themeWrapper.style.setProperty(
            '--okx-textfield-color',
            styles.colors['--okx-textfield-color'],
          );
        }
        if (styles.colors['--okx-textfield-border']) {
          themeWrapper.style.setProperty(
            '--okx-textfield-border',
            styles.colors['--okx-textfield-border'],
          );
        }
        if (styles.colors['--okx-menu-background']) {
          themeWrapper.style.setProperty(
            '--okx-menu-background',
            styles.colors['--okx-menu-background'],
          );
        }
        if (styles.colors['--okx-menu-color']) {
          themeWrapper.style.setProperty('--okx-menu-color', styles.colors['--okx-menu-color']);
        }
        if (styles.colors['--okx-menu-icon-color']) {
          themeWrapper.style.setProperty(
            '--okx-menu-icon-color',
            styles.colors['--okx-menu-icon-color'],
          );
        }
        if (styles.colors['--okx-menu-button-text']) {
          themeWrapper.style.setProperty(
            '--okx-menu-button-text',
            styles.colors['--okx-menu-button-text'],
          );
        }
        if (styles.colors['--okx-menu-button-background']) {
          themeWrapper.style.setProperty(
            '--okx-menu-button-background',
            styles.colors['--okx-menu-button-background'],
          );
        }
        if (styles.colors['--ion-color-gray']) {
          themeWrapper.style.setProperty(
            '--ion-color-gray',
            styles.colors['--ion-color-gray'],
          );

        } else {
          themeWrapper.style.setProperty('--ion-color-gray', '#EBEBEB');

        }
      }
      return true;
    });
  }
  if (styles.useBackgroundImages && styles.backgroundImages) {
    if (styles.backgroundImages['--okx-menu-background-image']) {
      themeWrapper.style.setProperty('--okx-menu-background-image', `url(${styles.backgroundImages['--okx-menu-background-image']})`);
      themeWrapper.style.setProperty('--okx-menu-background', 'transparent');

    }
  }
  if (styles.fontSizes) {
    Object.entries(styles.fontSizes).map(([key, value]) => {
      themeWrapper.style.setProperty(key, value);
      return true;
    });
  }
  if (styles.letterSpacing) {
    Object.entries(styles.letterSpacing).map(([key, value]) => {
      themeWrapper.style.setProperty(key, value);
      return true;
    });
  }
  if (useCustomFonts) {
    const customFontBold = new FontFace('primary-bold', `url(${require(`../../assets/fonts/${styles.fonts.customFontBold}`)})`);
    const customFontRegular = new FontFace('primary-regular', `url(${require(`../../assets/fonts/${styles.fonts.customFontRegular}`)})`);
    customFontBold.load().then(function (loadedFont) {
      document.fonts.add(loadedFont);
      document.body.style.fontFamily = 'primary-bold'
    })
    customFontRegular.load().then(function (loadedFont) {
      document.fonts.add(loadedFont);
      document.body.style.fontFamily = 'primary-regular'
    })

  } else {
    if (styles.fonts) {
      Object.entries(styles.fonts).map(([key, value]) => {
        WebFont.load({
          google: {
            families: [value],
          },
        });
        themeWrapper.style.setProperty(key, value);
        return true;
      });
    }
  }
  if (styles.loyaltyImageAspectRatio) {
    css += `
    .loyalty-header-with-image-wrapper .loyalty-card-image img{
    aspect-ratio: ${styles.loyaltyImageAspectRatio.replace(':', '/')}
    }
    `
  }
  if (styles.dashboardCardAspectRatio) {
    css += `
    .dashboard-card img{
    aspect-ratio: ${styles.dashboardCardAspectRatio.replace(':', '/')};
    height:unset !important;
    }
    `
  }
  if (styles.titleCentered) {
    css += `
    ion-text:has(.page-title-centered:not(:empty)){
  width: 100%;
}
.page-title-centered.title:not(:empty)::before,.web .modal-title::before{
  content: '';
  width: 200px;
  height: 3px;
  background-color: var(--okx-title-decorator-color);
  left: 0;
  right: 0;
  margin: auto;
  position: absolute;
  bottom:0;
}
.page-title-centered.title:not(:empty),.modal-title{
  padding-bottom: var(--spacer-2) !important;
}
.page-title-centered,.modal-title{
  width: 100%;
  text-align: center;
  position: relative;
}
    ion-app:not(.web) .order-list-items.box-with-shadow .order-sublist-header{
    margin-left:0 !important
    }
    `
  }
  if (styles.dashboardSliderAspectRatio) {
    css += `
    .route-dashboard .swiper-slide img,.route-loyalty:has(.loyalty-register-page) .swiper-slide img{
    aspect-ratio: ${styles.dashboardSliderAspectRatio.replace(':', '/')};
    height:unset !important;
    }
    `
  }
  if (styles.vouchersAspectRatio) {
    css += `
    .voucher-image{
    aspect-ratio: ${styles.vouchersAspectRatio.replace(':', '/')};
    height:unset !important;
    }
    `
  }
  if (styles.uppercaseButtons) {
    css += `
  ion-button.button-uppercase,.button-uppercase,ion-button.link,.alert-button > span,ion-button.underlined, .button.link:not(.legal-pages-btn){
  text-transform: uppercase !important}
  `
  }
  if (styles.legalButtonsTextTransform) {
    css += `
    .legal-pages-btn{
    text-transform:${styles.legalButtonsTextTransform}
  }
    `
  }
  if (styles.maximumWindowWidth) {
    css += `@media screen  and (min-width:${styles.maximumWindowWidth}){ 
    :root{
        --ion-padding-side:calc((100vw - ${styles.maximumWindowWidth}) / 2 + var(--ion-padding))
    }
}`;
  }
  if (styles.menuTilesWordBreak) {
    css += `.grid-menus .order-categories-tile-title{
    word-break:${styles.menuTilesWordBreak}!important;
    }`
  }
  if (styles.underlinedLinks) {
    css += `.link{
    text-decoration:underline;
    }`;
  }
  if (styles.isRoundButton) {
    css += `ion-button, .delivery-options-menu ion-item {
	  --border: 1px solid;
	  --border-radius: 20px;
	  border-radius: 20px;
	}`;
  }
  if (styles.milestoneOpacity) {
    css += `
    
.milestone-reward-earned .milestone-reward-image{
  opacity: ${styles.milestoneOpacity}
  }
    `
  }
  if (styles.milestoneDesciptionBottomBanner) {
    css += `
  .milestones-wrapper .loyalty-reward.milestone-reward .loyalty-reward-name {
  position: static;
  z-index: 1;
  left: unset;
  bottom: unset;
}

.milestones-wrapper .loyalty-reward.milestone-reward {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.milestones-wrapper .loyalty-reward.milestone-reward .loyalty-reward-name {
  padding: var(--ion-padding);
  width: 100%;
}
.milestones-wrapper .loyalty-reward.milestone-reward .loyalty-reward-name * {
  color: var(--okx-label-color) !important;
}
.milestones-wrapper .loyalty-reward.milestone-reward img {
  border-radius: var(--okx-box-radius);
}

.milestone-wrapper .loyalty-rewards-wrapper {
  padding: 0 0 0 var(--ion-padding);
}
  `
  }

  if (Capacitor.getPlatform() === 'ios') {
    themeWrapper.style.setProperty(
      '--safe-area-inset-top',
      'env(safe-area-inset-top)',
    );
  }
  if (Capacitor.isNativePlatform()) {
    css += `
    ion-app:not(.web) ion-header ion-toolbar:first-of-type,ion-app ion-toolbar.primary-toolbar {
  margin-top: var(--safe-area-inset-top, 0) !important;
}
  ion-modal.modal-classic:not(.modal-type-alert) .modal-classic-content{
  margin-top:calc(var(--safe-area-inset-top, 0) + var(--ion-padding)) !important;
  }
    ion-modal.modal-classic:not(.modal-type-alert) .modal-classic-closer,ion-modal.modal-classic:not(.modal-type-alert) .modal-back-arrow-closer {
  top: calc(var(--safe-area-inset-top, 0) + var(--ion-padding)) !important;
 
}
    `
  }
  if (styles.textDecorator) {
    css += `
    .title:not(:empty):not(.no-text-decorator):not(.no-decorator)::after,
    .alert-title:not(.no-text-decorator)::after,
    .text-to-update:not(.no-text-decorator):after,
    .input-field-container .strong-text:not(.no-text-decorator):after,
    .restaurant-selection .mbsc-sc-itm:not(:empty):not(.no-text-decorator)::after,
    .modal-title:not(.no-text-decorator)::after{
      content:'${styles.textDecorator}'
    }
    .input-field-container .strong-text.required-field:not(.no-text-decorator):after {
      content:'${styles.textDecorator}*'
    }
    .input-field-container .strong-text.required-field.no-text-decorator:after {
      content:'*'
    }
    `
  }

  if (!window._decoratorObserver) {
    const decoratorSelectors = ['.title', '.alert-title', '.text-to-update', '.input-field-container .strong-text', '.restaurant-selection .mbsc-sc-itm', '.modal-title'];
    let rafPending = false;
    const markQuestionElements = () => {
      if (rafPending) return;
      rafPending = true;
      requestAnimationFrame(() => {
        rafPending = false;
        if (styles.textDecorator) {
          document.querySelectorAll('.input-field-container .strong-text').forEach((el) => {
            const textNode = [...el.childNodes].reverse().find((node) => node.nodeType === Node.TEXT_NODE && node.nodeValue.trim());
            if (textNode && /\*\s*$/.test(textNode.nodeValue)) {
              textNode.nodeValue = textNode.nodeValue.replace(/\s*\*\s*$/, '');
              el.classList.add('required-field');
            }
          });
        }
        decoratorSelectors.forEach((selector) => {
          document.querySelectorAll(selector).forEach((el) => {
            if (/[.?!:;,…]$/.test(el.textContent.trimEnd())) {
              el.classList.add('no-text-decorator');
            } else {
              el.classList.remove('no-text-decorator');
            }
          });
        });
      });
    };
    window._decoratorObserver = new MutationObserver(markQuestionElements);
    window._decoratorObserver.observe(document.body, { childList: true, subtree: true, characterData: true });
    markQuestionElements();
  }

  setCustomImages(images, documentStyle, css);
};
/* On init app */
export const initSaga = function* () {
  while (true) {
    yield take(INIT);
    let clientId = null;
    if (Capacitor.isNativePlatform()) {
      const info = yield call(AppCap.getInfo);
      const appVersionFromDevice = info.version;
      clientId = parseInt(appVersionFromDevice.split('.')[0]);
    }
    yield call(api.createAxiosInstance);
    const config = yield call(api.getFrontEndAppConfig, clientId);
    const navConfig = yield call(initRouter, config, clientId);
    yield put({ type: SET_NAVCONFIG, data: navConfig });

    const token = yield call(asyncStorage.getItem, 'token');
    const profile = yield call(asyncStorage.getItem, 'profile');
    try {
      if (token && profile && profile !== '{}') {
        const refreshTokenResponse = yield call(api.refreshToken, { refresh: token });
        if (refreshTokenResponse && refreshTokenResponse.data && refreshTokenResponse.data.token) {
          const newToken = refreshTokenResponse.data.token;
          yield call(asyncStorage.setItem, 'token', newToken);
          yield call(api.createAxiosInstance, newToken);
        }
      }
    } catch (error) {
      yield put({ type: LOGOUT });
    }

    // get config for front-end from BO
    const frontEndAppConfig = {
      ...config.front_end_app_config,
      timezone: config.timezone || 'Europe/London',
      stamp_cards_json: config.stamp_cards_json || [],
      tiers_json: config.tiers_json || []
    };
    const { hasOrdering, hasBillPay, useCustomFonts, hasGiftVouchers, hasMembership } = config.front_end_app_config.flags;

    yield put({ type: SET_COMMON_PROP, key: 'clientStyles', value: config.styles });
    const client = yield call(api.getClient, clientId);
    document.title = client.buisiness_name;
    const favicon_image = client.favicon_image;
    const favicon = document.getElementById('favicon');
    favicon.href = favicon_image;
    yield put({ type: SET_COMMON_PROP, key: 'clientProfile', value: client });
    if (getConfig().payment === 'judopay') {
      // console.log('judopay');
    } else {
      // get public stripe key from BO
      if (hasOrdering || hasGiftVouchers || hasMembership) {
        const publicStripeKey = yield call(api.getPublicStripeKey);
        frontEndAppConfig.services.stripe_key = publicStripeKey;
        //init stripe plugin
        yield call(LibStripe.setStripePublishableKey, publicStripeKey);
      }
    }

    let mergedConfig = mergeConfigs(frontEndAppConfig, getConfig());
    mergedConfig = mergeConfigs(
      {
        merchantId: mergedConfig.envs.PAYMENT_MERCHANT,
        paymentsLive: mergedConfig.envs.PAYMENTS_LIVE,
      },
      mergedConfig,
    );
    updateConfig(mergedConfig);

    // get device language
    if (!mergedConfig.localization) {
      mergedConfig.localization = {};
      updateConfig(mergedConfig);
    }

    const localization = getConfig().localization;
    const deviceLanguageCode = yield call(Device.getLanguageCode);
    let sysLocale = deviceLanguageCode.value.substr(0, 2);
    if (
      Capacitor.getPlatform() !== 'web' &&
      localization &&
      localization.supportedLocales &&
      localization.supportedLocales[sysLocale]
    ) {
      mergedConfig.localization.defaultLocale = sysLocale;
      updateConfig(mergedConfig);
    }
    setCustomDesign(config.styles, config.custom_css, config.images, useCustomFonts, config.front_end_app_config.customButtons);

    if (Capacitor.getPlatform() == 'web') {
      sysLocale = window.navigator.userLanguage || window.navigator.language;
      if (sysLocale) {
        sysLocale = sysLocale.substr(0, 2);
      }
      if (getConfig().localization.supportedLocales[sysLocale]) {
        mergedConfig.localization.defaultLocale = sysLocale;
        updateConfig(mergedConfig);
      }
    }
    if (getConfig().loyaltyAccessUserIds) {
      if (getConfig().loyaltyAccessUserIds.includes(JSON.parse(profile)?.id) && JSON.parse(profile)?.id) {
        mergedConfig.flags.hasLoyalty = true
        updateConfig(mergedConfig);
        const navConfig = yield call(initRouter, { front_end_app_config: mergedConfig }, clientId);
        yield put({ type: SET_NAVCONFIG, data: navConfig });
      }
    }
    SplashScreen.hide();
    let translationCatalogFromAdmin = frontEndAppConfig && frontEndAppConfig.client && frontEndAppConfig.client.translation_json ? frontEndAppConfig.client.translation_json : {};
    const mergedTranslate = mergeTranslate(translationCatalogFromAdmin, translationCatalog);
    yield call(setCatalog, mergedTranslate);
    yield put({
      type: SET_COMMON_PROP,
      key: 'translationCatalog',
      value: mergedTranslate,
    });


    // remove all console.log messages if appConfig.general.debug is FALSE
    if (console && isDefined(getConfig().general.debug) && !getConfig().general.debug) {
      // don't try this at home :)
      // eslint-disable-next-line no-console
      // console.log = () => { };
    }

    yield call(restoreAuthSaga);

    //add firebase listeners for push notification
    yield put({ type: INIT_FIREBASE });
    try {
      yield spawn(firebaseDatabase);
    } catch (e) {
      yield call(errorHandlerSaga, e);
    }
    if (hasBillPay) {
      const basketFromStorage = yield call(asyncStorage.getItem, 'basket');
      const bill_data = JSON.parse(basketFromStorage)?.bill_data;
      if (!isEmptyObject(bill_data)) {
        yield put({
          type: INIT_FIREBASE_LISTENER,
          tableNumber: bill_data.table_number,
          tableBillId: bill_data.id,
        });
      }
      yield put({ type: SET_TABLE_DATA, key: 'tableData', value: bill_data });
    }
    //add app version
    let minAppVersion = yield call(api.getAppVersion);
    minAppVersion = parseInt((minAppVersion || '1').replaceAll('.', ''));
    yield put({ type: SET_COMMON_PROP, key: 'appVersion', value: minAppVersion });

    const deliveryRangeType = yield call(api.getDeliveryRangeType);
    yield put({ type: SET_COMMON_PROP, key: 'deliveryRangeType', value: deliveryRangeType });

    const defaultMenuId = yield call(api.getDefaultMenuId);
    yield put({ type: SET_COMMON_PROP, key: 'defaultMenuId', value: defaultMenuId });

    if (defaultMenuId) {
      try {
        let defaultMenu = yield call(api.getDefaultMenu, defaultMenuId);
        defaultMenu = yield call(filterMenu, deepCopy(defaultMenu), true);

        yield put({
          type: SET_RESTAURANT_PROP,
          key: 'defaultMenu',
          value: { ...defaultMenu, menuName: `${defaultMenu.menuName} Default` },
          merge: true,
        });
      } catch (err) {
        yield put({
          type: SET_RESTAURANT_PROP,
          key: 'ikentooMenuError',
          value: true
        });
      }

    } else if (hasOrdering) {
      console.error('Default Menu is not added!')
    }

    const restaurants = yield call(api.getRestaurants);

    const sortedRestaurants = [...restaurants].sort((a, b) => {
      if (a.distance != null && b.distance != null) {
        return a.distance - b.distance;
      } else if (a.distance == null && b.distance == null) {
        return a.name.localeCompare(b.name);
      } else if (a.distance == null) {
        return 1;
      } else {
        return -1;
      }
    });
    yield put({ type: SET_RESTAURANT_PROP, key: 'restaurants', value: sortedRestaurants });
    let businessLocationIds = [];
    restaurants.filter(el => el.can_bill_pay).map((restaurant) => {
      return businessLocationIds.push(restaurant.pos_location_id);
    });
    if (hasBillPay) {
      yield call(getTableNumbers, businessLocationIds.filter(Boolean));

    }
    const allergens = yield call(api.getAllergens);
    if (!allergens.data.error) {
      yield put({
        type: SET_RESTAURANT_PROP,
        key: 'allergens',
        value: allergens,
      });
    } else {
      yield put({
        type: SET_RESTAURANT_PROP,
        key: 'allergens',
        value: { data: [] },
      });
    }
    if (hasOrdering || hasGiftVouchers || hasMembership) {
      yield call(Basket.import, null, client.is_multi_basket);
    }
    if (getConfig().flags?.hasCuratedMenus && Basket.curated_menu && Basket.curated_menu !== true) {
      try {
        const { curatedMenu, ikentooMenu } = yield call(buildCuratedMenuSaga, Basket.curated_menu, Basket.order_type, Basket.getASAP() ? null : Basket.getCollectionTime());
        yield put({ type: SET_ORDERS_PROP, key: 'selectedCuratedMenuId', value: Basket.curated_menu });
        yield put({ type: SET_ORDERS_PROP, key: 'curatedMenu', value: curatedMenu });
        yield put({ type: SET_RESTAURANT_PROP, key: 'ikentooMenu', value: ikentooMenu });
      } catch (err) {
        yield put(showToast(yield call(translateSaga, 'Get curated menu error.'), 'warning'));
      }
    } else if (Basket.getMenu() && !isEmptyObject(Basket.getRestaurant())) {
      try {

        let businessLocationId = Basket.getRestaurant().business_location_id;
        let ikentooMenu = yield call(api.getIkenooMenu, Basket.getMenu(), businessLocationId, Basket.order_type);
        ikentooMenu = yield call(filterMenu, deepCopy(ikentooMenu));
        yield put({
          type: SET_RESTAURANT_PROP,
          key: 'ikentooMenu',
          value: ikentooMenu,
        });
      } catch (err) {
        Basket.reset()
        yield put(showToast(yield call(translateSaga, 'An error occurred.'), 'danger'));
        const defaultRoute = getDefaultRoute(navConfig);
        if (defaultRoute.path) {
          forwardTo(defaultRoute.path)
        }
      }

    }

    yield put({ type: SET_COMMON_PROP, key: 'initLoading', value: false });
    const deviceFcmToken = yield call(asyncStorage.getItem, 'deviceFcmToken');
    if (deviceFcmToken) {
      yield call(saveFcmToken, deviceFcmToken);
    }
    // setCustomImages();
    if (Capacitor.getPlatform() !== 'web' && minAppVersion > parseInt((packageJson.version || '1').replaceAll('.', ''))) {
      yield put({ type: SET_COMMON_PROP, key: 'updateAppModal', value: true });
    }
    if (Capacitor.getPlatform() === 'web') {
      configureProgressiveWebApp(config, client);
    }
  }
};
const setCustomImages = (images, sheet, css) => {
  if (images.favicon_image) {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = images.favicon_image;
  }

  if (images.main_image) {
    css += `
	.web .ion-page > ion-content {
	  background-image: url(${images.main_image});
	  background-repeat: no-repeat;
	  background-position: 50% 0;
	  background-size: cover;
	}

	`;
    if (getConfig().general.dashboardImage) {
      css += `
    ion-content div.dash-layout:before {
      content: "";
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      height: 60%;
      z-index: 0;
      background-image: url('${getConfig().general.dashboardImage}');
      background-repeat: no-repeat;
  }
    `
    }

  }

  sheet.innerHTML = css;
  document.body.appendChild(sheet);
};

/* social Saga */
export const socialSagaFlow = function* () {
  while (true) {
    yield take(GET_SOCIALS);
    //get socials
    yield call(loading, function* () {
      const social = yield call(api.getSocialLinks);
      yield put({ type: SET_COMMON_PROP, key: 'social', value: social });
    });
  }
};

/* send Feedback Saga */
export const sendFeedbackSaga = function* () {
  while (true) {
    const action = yield take(SEND_FEEDBACK);
    yield call(loading, function* () {
      const {
        food,
        service,
        commentService,
        commentTech,
        selectedRestaurant,
        customerService,
        orderTypeFeedback,
      } = action.data;
      const profile = yield select((store) => store.profile.profile);
      const metadata = yield call(getFeedbackMetadata, profile);
      const customerServicePayload = {
        selected_restaurant: selectedRestaurant,
        feedback_type: 'app customer_service',
        food_score: food,
        service_score: service,
        feedback_response: commentService,
        order_type: orderTypeFeedback,
        additional_data:metadata,
      };
      const techServicePayload = {
        selected_restaurant: selectedRestaurant,
        feedback_type: 'app tech_support',
        feedback_response: commentTech,
        order_type: orderTypeFeedback,
        additional_data:metadata,
      };
      //send feedback
      if (customerService) {
        yield call(api.sendFeedback, customerServicePayload);
      } else {
        yield call(api.sendFeedback, techServicePayload);
      }
      yield put({
        type: SET_COMMON_MODAL,
        modal: 'isFeedbackModalOpen',
        value: true,
      });
    });
  }
};
/* terms Saga */
export const getTermsFlow = function* () {
  while (true) {
    yield take(GET_TERMS);
    const locale = yield call(getLocaleFlow);
    const client_name = yield select((store) => store.common.clientProfile.name);
    yield call(loading, function* () {
      const terms = yield call(api.getTerms, locale, client_name);
      yield put({ type: SET_COMMON_PROP, key: 'terms', value: terms });
    });
  }
};

/* policy Saga */
export const getPrivacyPolicyFlow = function* () {
  while (true) {
    yield take(GET_PRIVACY_POLICY);
    const locale = yield call(getLocaleFlow);
    const client_name = yield select((store) => store.common.clientProfile.name);

    yield call(loading, function* () {
      const privacyPolicy = yield call(api.getPrivacyPolicy, locale, client_name);
      yield put({ type: SET_COMMON_PROP, key: 'privacyPolicy', value: privacyPolicy });
    });
  }
};

/* faq Saga */
export const getFaqFlow = function* () {
  while (true) {
    yield take(GET_FAQ);
    const locale = yield call(getLocaleFlow);
    const client_name = yield select((store) => store.common.clientProfile.name);

    yield call(loading, function* () {
      const faq = yield call(api.getFaq, locale, client_name);
      yield put({ type: SET_COMMON_PROP, key: 'faq', value: faq });
    });
  }
};

/* firebase Saga */
export const firebaseFlow = function* () {
  while (true) {
    yield take(INIT_FIREBASE);
    if (Capacitor.getPlatform() !== 'web') {
      try {
        // Register with Apple / Google to receive push via APNS/FCM
        let result = { receive: 'granted' }  // yield call(PushNotifications.checkPermissions());
        try {
          result = yield call(PushNotifications.requestPermissions);
        } catch (error) {
          result.receive = 'granted';
          //alert('Error on PushNotifications registration: ' + JSON.stringify(error));
        }
        if (result.receive === 'granted') {
          yield call(PushNotifications.register);
          const firebaseChannel = eventChannel((emitter) => {
            PushNotifications.addListener('registration', async (token) => {
              await asyncStorage.setItem('deviceFcmToken', token.value)
              emitter({
                type: 'registration',
                value: token.value,
              });
            });

            // Some issue with your setup and push will not work
            PushNotifications.addListener('registrationError', (error) => {
              emitter({
                type: 'registrationError',
                value: error,
              });
            });

            // Show us the notification payload if the app is open on our device
            PushNotifications.addListener('pushNotificationReceived', (notification) => {
              emitter({
                type: 'pushNotificationReceived',
                value: notification,
              });
            });

            // Method called when tapping on a notification
            PushNotifications.addListener('pushNotificationActionPerformed', (notification) => {
              emitter({
                type: 'pushNotificationActionPerformed',
                value: notification,
              });
            });
          });

          while (true) {
            const firebaseMessage = yield take(firebaseChannel);
            // eslint-disable-next-line no-console
            switch (firebaseMessage.type) {
              case 'registration': {
                yield put({
                  type: SET_COMMON_PROP,
                  key: 'deviceFcmToken',
                  value: firebaseMessage.value,
                });
                break;
              }
              default:
            }
          }
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.log('INIT_FIREBASE_ERROR', error);
      }
    }
  }
};




const checkFibaseDBProperty = function* (propName, obj = {}) {
  let ret = false;
  const storagePropName = propName + '_firebase';
  if (obj?.table || obj[propName]) {
    const storagePropValue = yield call(asyncStorage.getItem, storagePropName);
    if (!storagePropValue || storagePropValue !== (obj?.table || obj[propName])) {
      yield call(asyncStorage.setItem, storagePropName, obj?.table || obj[propName]);
      ret = true;
    }
  }
  return ret;
};


export const firebaseDatabaseFlow = function* () {
  while (true) {
    yield take(INIT_FIREBASE_DATABASE);
    yield call(firebaseDatabase);
  }
};

export const firebaseDatabase = function* () {
  const profileId = yield select((store) => store.profile.profile.id);
  const auth = yield select((store) => store.profile.auth);
  const firebaseChannel = eventChannel((emitter) => {
    const client_id = getConfig().client.client_id;

    const connection = !getApps().length
      ? initializeApp(getConfig().firebaseConfig)
      : getApp();
    const firebaseDatabase = getDatabase(connection);
    const restaurants = ref(firebaseDatabase, 'restaurants');

    const client = ref(firebaseDatabase, `client_${client_id.toString()}`);
    const clientEvents = ref(firebaseDatabase, `client_${client_id.toString()}/events`);

    if (auth && auth.loggedIn) {
      const db = ref(firebaseDatabase, profileId);
      onValue(db, (snap) => {
        let db_record = snap.val();
        if (db_record) {
          emitter({ type: 'db', value: db_record });
        }
      });

      const clientDb = ref(firebaseDatabase, `${profileId}_${client_id.toString()}`);
      onValue(clientDb, (snap) => {
        let db_record = snap.val();
        if (db_record) {
          emitter({ type: 'db', value: db_record });
        }
      });
    }
    onValue(restaurants, (snap) => {
      let db_record = snap.val();
      if (db_record) {
        emitter({ type: 'db', value: db_record });
      }
    });
    onValue(client, (snap) => {
      let db_record = snap.val();
      if (db_record) {
        emitter({ type: 'db', value: db_record });
      }
    });
    onValue(clientEvents, (snap) => {
      let db_record = snap.val();
      if (db_record) {
        emitter({ type: 'events', value: db_record });
      }
    });
    // unsubscribe function
    return () => { };
  });

  while (true) {
    const firebaseMessage = yield take(firebaseChannel);
    // eslint-disable-next-line no-console
    console.log('firebase database message', firebaseMessage);
    const { type, value } = firebaseMessage;
    let valueArray = Object.keys(value).map((key) => ({
      key,
      value: value[key],
    }));
    switch (type) {
      case 'db': {
        const auth = yield select((store) => store.profile.auth);
        if (auth && auth.loggedIn) {
          if (yield call(checkFibaseDBProperty, 'client_data', value)) {
            const client = yield call(api.getClient);
            document.title = client.buisiness_name;
            const favicon_image = client.favicon_image;
            const favicon = document.getElementById('favicon');
            if (favicon) {
              favicon.href = favicon_image;
            }
            yield put({
              type: SET_COMMON_PROP,
              key: 'clientProfile',
              value: client,
            });
            yield put({
              type: SET_COMMON_PROP,
              key: 'clientProfileUpdated',
              value: value.client_data,
            });
          }
          if (yield call(checkFibaseDBProperty, 'timestamp', value)) {
            yield put({ type: GET_PROFILE, skipLoading: true });
          }
          if (yield call(checkFibaseDBProperty, 'vouchers', value)) {
            yield put({ type: GET_VOUCHERS });
          }
          if (yield call(checkFibaseDBProperty, 'rewards', value)) {
            yield put({ type: GET_REWARDS });
          }
          if (yield call(checkFibaseDBProperty, 'reward_milestones', value)) {
            yield put({ type: GET_REWARDS });
          }
          if (yield call(checkFibaseDBProperty, 'gift_cards', value)) {
            yield put({ type: GET_GIFT_CARDS });
          }
          if (yield call(checkFibaseDBProperty, 'notifications', value)) {
            yield put({ type: GET_NOTIFICATIONS });
          }
          if (yield call(checkFibaseDBProperty, 'order_history', value)) {
            yield put({ type: GET_ORDER_HISTORY, loading: false });
          }
          let latestOrderId = -Infinity;
          for (let i = 0; i < valueArray.length; i++) {
            let orderId = valueArray[i].key;
            let curentOrderId = +orderId;
            if (!isNaN(curentOrderId)) {
              if (curentOrderId > latestOrderId) {
                latestOrderId = curentOrderId;
              }
            }
          }
          if (yield call(checkFibaseDBProperty, latestOrderId.toString(), value) && window.location.pathname == '/order-completed' && latestOrderId !== -Infinity) {
            const lastOrderResult = yield call(api.getLastOrder, latestOrderId.toString());
            let orderHistory = [];
            if (getConfig()?.flags?.squareClient) {
              orderHistory = yield call(api.getOrderHistory, 1);
            } else {
              orderHistory = yield select((store) => store.orders.orderHistory);
            }
            if (lastOrderResult.is_parent_order) {
              let newOrderHistory = [...orderHistory];
              if (orderHistory && lastOrderResult) {
                newOrderHistory = newOrderHistory.map((order) => {
                  const multi_basket_items = (order.multi_basket_items || []).map((el) => {
                    const updatedItem = (lastOrderResult.multi_basket_items || []).find((item) => item?.restaurant?.id && item.restaurant.id == el?.restaurant?.id);
                    return updatedItem ? { ...el, status: updatedItem.status } : el;
                  });
                  if (order.id === lastOrderResult.id) {
                    return {
                      ...order,
                      ...lastOrderResult,
                      multi_basket_items,
                    };
                  } else {
                    return order;
                  }
                });
              }
              yield put({
                type: SET_ORDERS_PROP,
                key: 'orderHistory',
                value: newOrderHistory,
              });
            } else {
              const parentOrderResult = yield call(api.getLastOrder, lastOrderResult.parent_order_id);
              let parentOrderHistory = [...orderHistory];
              if (orderHistory && parentOrderResult) {
                parentOrderHistory = parentOrderHistory.map((order) => {
                  if (order.id === parentOrderResult.id) {
                    return {
                      ...order,
                      ...parentOrderResult,
                    };
                  } else {
                    return order;
                  }
                });
              }
              yield put({
                type: SET_ORDERS_PROP,
                key: 'orderHistory',
                value: parentOrderHistory,
              });
            }
          }
        }
        if (yield call(checkFibaseDBProperty, Basket.getUUID(), value)) {
          yield put({
            type: GET_TAX_DATA,
            uuid: Basket.getUUID(),
          });
        }
        if (yield call(checkFibaseDBProperty, 'restaurant_snooze_data', value)) {
          // get restaurants snoozed data
          yield put({ type: GET_RESTAURANTS_SNOOZED_DATA });
          yield put({
            type: SET_RESTAURANT_PROP,
            key: 'restaurantsUpdated',
            value: value.restaurant_snooze_data,
          });
        }
        break;
      }
      case 'events': {
        const currentEvent = yield select((store) => store.orders.event);
        const basketItems = Basket.isEvent() ? Basket.getItems() : [];
        for (let i = 0; i < valueArray.length; i++) {
          const key = valueArray[i].key;
          const eventId = key.replace('event_', '');
          if (yield call(checkFibaseDBProperty, key, value)) {
            const isViewedEvent =
              ['/event-details', '/event-tickets'].indexOf(window.location.pathname) !== -1 &&
              currentEvent &&
              currentEvent.id.toString() === eventId;
            const isBasketEvent = basketItems.some(
              (basketItem) => basketItem.item?.event_id?.toString() === eventId,
            );
            if (isViewedEvent || isBasketEvent) {
              yield put({
                type: GET_EVENT,
                idOrSlug: eventId,
                skipLoading: true,
                skipStore: !isViewedEvent,
              });
            }
          }
        }
        break;
      }
      default:
    }
  }
};

export const saveFcmToken = function* (fcmToken = null) {
  const profile = yield select((store) => store?.profile?.profile);
  let deviceFcmToken = fcmToken;
  if (!deviceFcmToken) {
    deviceFcmToken = yield select((store) => store?.common?.deviceFcmToken);
  }
  if (!isEmptyObject(profile) && isDefined(profile) && isDefined(deviceFcmToken) && profile.fcm_token !== deviceFcmToken) {
    //save new fcm token
    yield put({ type: UPDATE_PROFILE, data: { fcm_token: deviceFcmToken }, skipAlert: true });
  }
};

// fetch user profile (if exists) and translate using profile.locale OR using default locale form config
export const translateSaga = function* (text) {
  const store = yield select();
  let locale = getConfig().localization.defaultLocale;
  if (store.profile && store.profile.profile && store.profile.profile.locale) {
    locale = store.profile.profile.locale;
  }
  return translate(text, locale);
};

export const getLocaleFlow = function* () {
  const store = yield select();
  let locale = getConfig().localization.defaultLocale;
  if (store.profile && store.profile.profile && store.profile.profile.locale) {
    locale = store.profile.profile.locale;
  }
  return locale;
};

export const locationFlow = function* () {
  while (true) {
    const action = yield take(LOCATION);
    const store = yield select();
    const myLocation = action.value || store.common.myLocation;
    yield put({ type: SET_COMMON_PROP, key: 'myLocation', value: myLocation });
    const restaurants = store.restaurants.restaurants;
    if (restaurants) {
      restaurants.forEach((restaurant) => {
        if (restaurant.position) {
          const [lat, lng] = restaurant.position.split(',');
          restaurant.latitude = parseFloat(lat);
          restaurant.longitude = parseFloat(lng);
        } else {
          const lat = getConfig().services.google_maps.defaultLat;
          const lng = getConfig().services.google_maps.defaultLng;
          restaurant.position = lat + ',' + lng;
          restaurant.latitude = lat;
          restaurant.longitude = lng;
        }
      });
      const sortRestaurants = yield call(sortLocations, restaurants, myLocation);
      yield put({ type: SET_RESTAURANT_PROP, key: 'restaurants', value: sortRestaurants });
      if (Basket.getRestaurant()) {
        const selectedRestaurant = sortRestaurants.find((restaurant) => restaurant.id === Basket.getRestaurant().id);
        Basket.setRestaurant(selectedRestaurant);
      }
    }
  }
};

/* order minutes Saga */
export const getOrderProductionFlow = function* () {
  while (true) {
    yield take(GET_ORDER_PRODUCTION_MINS);
    const order_production_mins = yield call(api.getOrderProduction);
    yield put({ type: SET_COMMON_PROP, key: 'orderProductionMins', value: order_production_mins });
  }
};
export const getNewsFlow = function* () {
  while (true) {
    yield take(GET_NEWS);
    const news = yield call(api.getNews);
    yield put({ type: SET_NEWS, value: news });
  }
};
export const getNutritionDataFlow = function* () {
  while (true) {
    yield take(GET_NUTRITION_DATA);
    const result = yield call(api.getNutritonData);
    yield put({ type: SET_NUTRITION_DATA, value: result });
  }
};
export const addToWalletFlow = function* () {
  while (true) {
    const { data } = yield take(ADD_TO_WALLET);
    yield call(loading, function* () {
      try {
        const response = yield call(api.addToGoogleWallet, data);
        if (response.error) {
          yield put(showToast(yield call(translateSaga, response.error), 'danger'));
        } else {
          window.open(response.url, '_system', 'location=yes');
        }
      } catch (error) {
        yield put({ type: REQUEST_ERROR, error: error.message });
      }
    });
  }
};

export const addToAppleWalletFlow = function* () {
  while (true) {
    const { data, cb } = yield take(ADD_TO_APPLE_WALLET);
    yield call(loading, function* () {
      try {
        const response = yield call(api.addToAppleWallet, data);
        if (response.error) {
          yield put(showToast(yield call(translateSaga, response.error), 'danger'));
        } else {
          if (Capacitor.getPlatform() === 'web') {
            const reader = new FileReader();
            reader.onloadend = async () => {
              const blobData = new Blob([response], { type: 'application/vnd.apple.pkpass' });
              const url = window.URL.createObjectURL(blobData);
              const link = document.createElement('a');
              link.href = url;
              link.download = `${data.passName}.pkpass`;
              link.click();
            };
            reader.readAsDataURL(response)
          } else {
            yield put({ type: LOADING, loading: true });
            const customPassKit = registerPlugin('PKPassKit');
            customPassKit.addListener('passResult', async (response) => {
              if (response?.passIsAdded) {
                cb("Apple Pass has been added to Wallet.", "success");
              } else if (response?.passIsUpdated) {
                cb("Apple Pass has been updated.", "success");
              } else if (response?.walletAppIsNotInstalled) {
                cb("Unable to add pass: The Wallet app is not installed.", "danger");
              } else if (response?.error) {
                cb("Error adding Apple Pass to Wallet.", "danger");
              }
            });
            const reader = new FileReader();
            reader.onloadend = async () => {
              const base64data = reader.result.split(',')[1];
              await customPassKit.replacePass({ base64data: base64data, orAdd: true });
            };
            reader.readAsDataURL(response)
          }
        }
      } catch (error) {
        console.log("Error adding to apple wallet:", error);
        yield put({ type: REQUEST_ERROR, error: error.message });
      }
    });
  }
};

export const getMilestoneRewardsInfoFlow = function* () {
  while (true) {
    yield take(GET_MILESTONE_INFO);
    const milestoneInfo = yield call(api.getMilestoneRewardsInfo);
    yield put({ type: SET_COMMON_PROP, key: 'milestoneInfo', value: milestoneInfo });
  }
};
export const getLoyaltyInfoFlow = function* () {
  while (true) {
    yield take(GET_LOYALTY_INFO);

    const loyaltyInfo = yield call(api.getLoyaltyInfo);
    yield put({ type: SET_COMMON_PROP, key: 'loyaltyInfo', value: loyaltyInfo });
  }
};

export const getUnlockRewardsInfoFlow = function* () {
  while (true) {
    yield take(GET_UNLOCK_INFO);

    const unlockRewardsInfo = yield call(api.getUnlockRewardsInfo);
    yield put({ type: SET_COMMON_PROP, key: 'unlockRewardsInfo', value: unlockRewardsInfo });
  }
};


function createChannel(data) {
  const client_id = getConfig().client.client_id;
  const connection = !getApps().length
    ? initializeApp(getConfig().firebaseConfig)
    : getApp();
  const firebaseDatabase = getDatabase(connection);
  const refPath = `table/client_${client_id}_table_${data}`;
  const databaseRef = ref(firebaseDatabase, refPath);

  const channel = eventChannel((emit) => {
    onValue(databaseRef, (snapshot) => {
      emit({ type: 'db', value: snapshot.val() });
    });

    return () => off(databaseRef, 'value');
  });

  return channel;
}

function* observeSuccesses(channel, tableBillId) {
  while (true) {
    const messages = yield take(channel);
    const basketFromStorage = yield call(asyncStorage.getItem, 'basket');
    const bill_data = JSON.parse(basketFromStorage)?.bill_data;
    const { type, value } = messages;
    if (bill_data.id == tableBillId) {
      const client_id = getConfig().client.client_id;
      switch (type) {
        case 'db':
          if (yield call(checkFibaseDBProperty, `table/client_${client_id}_table_${bill_data.table_number}`, value)) {
            yield put({ type: GET_TABLE_BY_ID, tableBillId });
          }
          break;

        default:
      }
    }
  }
}

export const firebaseListenerFlow = function* () {
  // neccessary if u need to provide cancelation logic
  const subscriptions = {};

  while (true) {
    const { tableNumber, tableBillId } = yield take(INIT_FIREBASE_LISTENER);
    const channel = createChannel(tableNumber);
    const task = yield fork(observeSuccesses, channel, tableBillId);
    subscriptions[tableNumber] = [channel, task];
  }
};

export const getAllergensInfoFlow = function* () {
  while (true) {
    yield take(GET_ALLERGENS);
    const client_name = yield select((store) => store.common.clientProfile.name);
    const locale = yield call(getLocaleFlow);
    yield call(loading, function* () {
      const allergensInfo = yield call(api.getAllergensInfo, locale, client_name);
      yield put({
        type: SET_COMMON_PROP,
        key: 'allergensInfo',
        value: allergensInfo,
      });
    });
  }
};

const configureProgressiveWebApp = (config, client) => {
  try {
    const favicon_image = client.favicon_image;
    const frontendConfig = config.front_end_app_config || {};
    const defaultPwaIcons = [
      { src: favicon_image, sizes: '192x192', type: 'image/png', platform: 'android' },
      { src: favicon_image, sizes: '512x512', type: 'image/png', platform: 'android' },
      { src: favicon_image, sizes: '1080x1080', type: 'image/png', platform: 'android' },
      { src: favicon_image, sizes: '180x180', platform: 'ios' },
    ];
    const pwaIcons = (frontendConfig?.pwaIcons && Array.isArray(frontendConfig.pwaIcons) && frontendConfig.pwaIcons.length > 0
      ? frontendConfig.pwaIcons
      : defaultPwaIcons
    ).map((icon) => ({
      src: icon.src,
      sizes: icon.sizes,
      type: icon.type || 'image/png',
      purpose: icon.purpose,
      platform: icon.platform || 'both',
    }));

    const icons = pwaIcons
      .filter((icon) => icon.platform !== 'ios')
      .map((icon) => ({
        src: icon.src,
        sizes: icon.sizes,
        type: icon.type,
        ...(icon.purpose ? { purpose: icon.purpose } : {}),
      }));
    const manifest = {
      "name": client.buisiness_name,
      "short_name": client.buisiness_name,
      "start_url": window.location.href,
      "display": "standalone",
      "background_color": config.styles["--okx-background-color"],
      "theme_color": config.styles["--okx-primary-color"],
      "icons": icons,
    };
    const manifestLink = document.createElement('link');
    const manifestBlob = new Blob([JSON.stringify(manifest)], { type: 'application/json' });
    const manifestURL = URL.createObjectURL(manifestBlob);
    manifestLink.rel = 'manifest';
    manifestLink.href = manifestURL;
    document.head.appendChild(manifestLink);
    document
      .querySelectorAll('link[rel="apple-touch-icon"], link[rel="apple-touch-icon-precomposed"]')
      .forEach((el) => el.parentNode && el.parentNode.removeChild(el));

    pwaIcons
      .filter((icon) => icon.platform !== 'android' && icon.src)
      .forEach((icon) => {
        const link = document.createElement('link');
        link.rel = 'apple-touch-icon';
        if (icon.sizes) link.setAttribute('sizes', icon.sizes);
        link.href = icon.src;
        document.head.appendChild(link);
      });

  } catch (error) {
    console.error('Error configurating progressive web app:', error);
  }
};